// SPDX-FileCopyrightText: 2016-2026 Lari Natri <lari.natri@iki.fi>
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * Escapes characters that are special in HTML text and quoted attributes.
 *
 * This is not a sanitizer and must not be used for JavaScript, CSS, URL, or
 * unquoted-attribute contexts. By default, entity-looking sequences are
 * preserved to avoid double encoding; pass `doubleEncode = true` to escape every
 * ampersand.
 */
export function htmlEncode(str: string | null | undefined, doubleEncode = false): string {
  if (str == null) return "";
  if (!str) return str;
  const ampersandPattern = doubleEncode ? /&/g : /&(?![a-zA-Z0-9#]+;)/g;
  return str
    .replace(ampersandPattern, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}
